import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "page-title" }, "Edition d'une mise en avant", -1)
const _hoisted_2 = { class: "form-container" }
const _hoisted_3 = { class: "justify-center" }
const _hoisted_4 = { class: "mx-auto shadow-md p-6 rounded-lg w-[90%] md:w-[80%] lg:w-[50%]" }
const _hoisted_5 = { class: "w-full lg:w-3/4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold text-sm" }, "Image *", -1)
const _hoisted_7 = { class: "flex mt-[1.5rem]" }

import ApiService from "@/_services/api.service";
import {onBeforeMount, onMounted, ref, watch} from "vue";
import router from "@/router";
import swal from "@/_helpers/swal";
import UploadImage from "@/components/forms/UploadImage.vue";
import CustomButton from "@/components/forms/CustomButton.vue";
import {useRoute} from "vue-router";
const propertyTagUuid = '3172dc3a-1ed9-468d-8cbc-dff34c441361';

export default /*#__PURE__*/_defineComponent({
  __name: 'MegaMenuCategoriesEdit',
  setup(__props) {

let categories = ref([]);
let imageMenu = ref();
let dataIsReady = ref(false);
let megaMenuData =ref({
    name:'',
    propertyValueUuid:'',
    propertyValueLabel:'',
    category:''
});
const route = useRoute();

onBeforeMount(
    async () => {
        await fetchCategories();
        await fetchMegaMenuData(route.params.uuid)
    }
)

async function fetchCategories() {
    try {
        const response = await ApiService.get('categories?lvl=1');
        categories.value = response.data.data.map((item: never) => {
            return {
                label: item.name, value: item.uuid
            };
        });
    } catch (error) {
        swal.error('An error occurred');
    }
}

async function searchTags({search}) {
    if (!search || search.length < 3) {
        return [
            {
                label: megaMenuData.value.propertyValueLabel,
                value: megaMenuData.value.propertyValueUuid
            }
        ];
    }
    const fetchTags = await ApiService.get(`property_values?property.uuid=${propertyTagUuid}&value=${search || ''}&status=true`);
    return fetchTags.data.data.map((val: any) => {
        return {
            label: val.value,
            value: val.uuid
        }
    });
}
const onImageUpload = (image) => {
    imageMenu.value = image;
}
const onImageRemoved = () => {
    imageMenu.value = null;
}
const onImageUploadError = (errorMsg: string) => {
    swal.error(errorMsg);
}

function getBaseUrl() {
    return window.location.origin;
}

function submitHandler(data, formNode) {
    if(!imageMenu.value){
        swal.error('l\'image est  obligatoire');
        return;
    }
    const uuid = route.params.uuid.toString();
    return ApiService.patch("/mega_menu_categories",uuid, {
        uuid: uuid,
        name: data.name,
        image: imageMenu.value.uuid,
        propertyValue: data.propertyValue,
        category: data.category

    }).then(() => {
        swal.success("Mise en avant modifiée !", "");
        router.push({name: 'listMegaMenusCategories'});
    }).catch(({response}) => {
        response.data.errors.forEach((error) => {
            formNode.setErrors(null, {[error.property]: error.message});
            return false;
        });
    });
}

const fetchMegaMenuData = async (megaMenuUuid) => {
    try {
        const response = await ApiService.get("/mega_menu_categories/" + megaMenuUuid);
        megaMenuData.value.propertyValueUuid = response.data.data.propertyValue.uuid;
        megaMenuData.value.propertyValueLabel = response.data.data.propertyValue.value;
        megaMenuData.value.name = response.data.data.name;
        megaMenuData.value.category = response.data.data.category.uuid;
        imageMenu.value = response.data.data.image;
        dataIsReady.value=true;
        
    } catch (error) {
    }
};


return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomButton, {
      to: { name: 'listMegaMenusCategories' },
      label: "Links.goBack"
    }),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_FormKit, {
            type: "form",
            value: true,
            actions: false,
            "incomplete-message": "Désolé, tous les champs ne sont pas remplis correctement.",
            onSubmit: submitHandler
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FormKit, {
                type: "select",
                name: "category",
                modelValue: _unref(megaMenuData).category,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(megaMenuData).category) = $event)),
                label: "Choix de la catégorie *",
                placeholder: "Choisissez une catégorie",
                validation: "required",
                options: _unref(categories),
                "validation-messages": {
                    required: 'La catégorie est obligatoire',
                  }
              }, null, 8, ["modelValue", "options"]),
              _createVNode(_component_FormKit, {
                type: "text",
                name: "name",
                modelValue: _unref(megaMenuData).name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(megaMenuData).name) = $event)),
                label: "Nom de la mise en avant *",
                placeholder: "Entrer un nom de la mise en avant",
                validation: "required|length:1,50",
                "validation-messages": {
                required: 'Ce champ est obligatoire.',
                length: 'Ce champ doit contenir maximum 50 caractères.',
                }
              }, null, 8, ["modelValue", "validation-messages"]),
              (_unref(dataIsReady))
                ? (_openBlock(), _createBlock(_component_FormKit, {
                    key: 0,
                    type: "autocomplete",
                    name: "propertyValue",
                    modelValue: _unref(megaMenuData).propertyValueUuid,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(megaMenuData).propertyValueUuid) = $event)),
                    label: "Tag de recherche *",
                    placeholder: "Choisissez une tag",
                    validation: "required",
                    options: searchTags,
                    "validation-messages": {
                    required: 'La tag est obligatoire',
                  }
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(UploadImage, {
                  "image-preview-url": _unref(imageMenu) ? _unref(imageMenu).url : getBaseUrl() + '/media/blank2.png',
                  onImageRemoved: onImageRemoved,
                  onImageUploaded: onImageUpload,
                  onError: onImageUploadError
                }, null, 8, ["image-preview-url"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_FormKit, {
                  type: "submit",
                  label: "Modifier",
                  class: "btn",
                  "prefix-icon": "check"
                })
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}
}

})